import { Alert } from "./Alert";
import React from "react";
import { useInstallationProgress } from "../../store/installation/hooks";

export function InstallationAlert(): JSX.Element {
  const progress = useInstallationProgress();

  if (!progress.completed && progress.alertCode) {
    return <Alert alertCode={progress.alertCode} />;
  }

  return <></>;
}
